import { useState } from "react";
import { ArrowRight, PenTool } from "lucide-react";
import { EnquiryDialog } from "@/components/EnquiryDialog";
import { GetSetDesignMark } from "@/components/GetSetDesignMark";

const POINTS = ["Original concepts drawn by hand", "Full vector files & brand guidelines", "Revisions until it feels right"];

export const CustomLogoBanner = () => {
  const [open, setOpen] = useState(false);
  return (
    <section className="relative overflow-hidden bg-[#0A0A0B] text-white border-b border-white/10" data-testid="custom-logo-banner">
      <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-[#ED5A24]/20 blur-3xl pointer-events-none" />
      <div className="absolute -left-24 bottom-0 w-80 h-80 rounded-full bg-[#1F8FED]/15 blur-3xl pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-7">
          <div className="flex items-center gap-3 mb-6">
            <PenTool className="w-4 h-4 text-[#ED5A24]" />
            <span className="text-xs uppercase tracking-[0.3em] font-bold text-white/60">Need something brand new?</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl tracking-tighter font-black leading-[1.05] mb-6">
            Custom logos, designed<br />
            <span className="bg-gradient-to-r from-[#ED5A24] to-[#1F8FED] bg-clip-text text-transparent">by real people.</span>
          </h2>
          <p className="text-base text-white/70 leading-relaxed max-w-xl mb-8">
            No logo to rescue? The Get Set Design team creates bespoke logos and brand identities from scratch —
            delivered with every vector format, a brand guidelines sheet and a social kit.
          </p>
          <ul className="space-y-2.5 mb-10">
            {POINTS.map((p) => (
              <li key={p} className="flex items-center gap-3 text-sm text-white/90">
                <span className="w-1.5 h-1.5 bg-[#ED5A24]" /> {p}
              </li>
            ))}
          </ul>
          <button
            type="button"
            onClick={() => setOpen(true)}
            data-testid="custom-logo-cta"
            className="group inline-flex items-center gap-2 bg-white text-[#0A0A0B] hover:bg-[#ED5A24] hover:text-white text-xs uppercase tracking-[0.2em] font-bold h-12 px-8 transition-colors duration-200"
          >
            Start a custom logo <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
          </button>
        </div>
        <div className="md:col-span-5">
          <div className="bg-white text-[#0A0A0B] p-8 md:p-10 text-center shadow-[0_30px_80px_-20px_rgba(237,90,36,0.35)]" data-testid="gsd-card">
            <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-[#52525B] mb-4">Designed by</div>
            <GetSetDesignMark />
            <div className="mt-6 text-sm text-[#52525B]">Logo & brand identity studio</div>
          </div>
        </div>
      </div>
      <EnquiryDialog open={open} onOpenChange={setOpen} />
    </section>
  );
};
